// extracted by mini-css-extract-plugin
export default {"root-container":"pxH9HACsPmGgpp55rJXT","content-container":"sytcMCBtB9eJS7X3elmn","dimmed-background":"Dn8jx3pja222ra9OB9iU"};